import { useSessionContext } from '@issuemanager/apps/client/contexts';

const formatDate = (format: string): string =>
  format.replace(/%m/, 'MM').replace(/%d/, 'DD').replace(/%Y/, 'YYYY');

const formatDateTime = (format: string): string => {
  const date = formatDate(format);
  return `${date} h:mm A`;
};

const calculateTimezoneOffset = (timezoneOffset: string): number => {
  const [hours, minutes] = timezoneOffset.split(':');
  const negative = hours.includes('-');
  const offset = (negative ? -hours.slice(1) : +hours) * 60;

  return negative ? offset - Number(minutes) : offset + Number(minutes);
};

export const useDateTimeFormat = (): {
  date: string;
  timezoneOffset: number;
  datetime: string;
} => {
  const { date_format: dateFormat, timezone_offset: timezoneOffset = '' } =
    useSessionContext();

  const date = formatDate(dateFormat);

  return {
    date,
    timezoneOffset: calculateTimezoneOffset(timezoneOffset),
    datetime: formatDateTime(dateFormat),
  };
};

export default useDateTimeFormat;
